
import { useState, useEffect, createContext } from "react";
const AppContext = createContext({});
// const { Provider } = AppContext;
function useGoodsOpenModal() {
    const [openGoodsItem, setOpenGoodsItem] = useState(false);
    const [openConfirmOrder, setOpenConfirmOrder] = useState(false);
    const [openOrderDetail, setOpenOrderDetail] = useState(false);
    const updateGoodsItem = (flag) => {
        setOpenGoodsItem(flag)
    }

    const updateOpenConfirmOrder = (flag) => {
        setOpenConfirmOrder(flag)
    }

    const updateOpenOrderDetail = (flag) => {
        setOpenOrderDetail(flag)
    }

    return {
        openGoodsItem,
        updateGoodsItem,
        openConfirmOrder,
        updateOpenConfirmOrder,
        openOrderDetail,
        updateOpenOrderDetail
    }
}

export {
    AppContext,
    useGoodsOpenModal
}




